export enum OrderType {
  "Open" = "Open",
  "Dicht" = "Dicht",
}
export enum ProfileColor {
  "Zwart" = "Zwart",
  "Aluminium" = "Aluminium",
}

export enum Material {
  HPL = "HPL", // "HPL" = "HPL"
  PVC = "PVC", // "PVC" = "PVC"
  WOVEN = "WOVEN",
  SENSE = "SENSE",
  "SENSE LETHER" = "SENSE LETHER",
  BETON = "BETON",
  // "HPL stootborden" = "HPL stootborden",
}

// Colors are now managed dynamically via the ColorOption table.
// Use getColors(material) from PricesContext instead of hardcoded enums.

export interface CompleteOrder {
  type: OrderType;
  profileColor: ProfileColor;
  stairMaterial: Material;
  stairColor: string;
  stairAmount: number;
  stairPrice: number;
  risersMaterial: Material;
  risersColor: string;
  risersAmount: string;
  risersPrice: number;
  topMaterial: Material;
  topColor: string;
  topAmount: string;
  topPrice: number;
  extrasLed: boolean;
  extrasPlateau: boolean;
  plateauMaterial?: Material;
  extrasVolfineer: boolean;
  first_name: string;
  last_name: string;
  email: string;
  phone: string;
  street: string;
  house_number: string;
  zipcode: string;
  city: string;
  assembly: boolean;
  finalPrice: number;
}

export interface IncompleteOrder {
  type?: OrderType;
  profileColor?: ProfileColor;
  stairMaterial?: Material;
  stairColor?: string;
  stairAmount?: number;
  stairPrice?: number;
  risersMaterial?: Material;
  risersColor?: string;
  risersAmount?: string;
  risersPrice?: number;
  topMaterial?: Material;
  topColor?: string;
  topAmount?: string;
  topPrice?: number;
  extrasLed?: boolean;
  extrasPlateau?: boolean;
  plateauMaterial?: Material;
  extrasVolfineer?: boolean;
  first_name?: string;
  last_name?: string;
  email?: string;
  phone?: string;
  street?: string;
  house_number?: string;
  zipcode?: string;
  city?: string;
  assembly?: boolean;
  finalPrice?: number;
}

export const materials = Object.keys(Material) as Material[];
export const profileColors = Object.keys(ProfileColor) as ProfileColor[];
export const orderTypes = Object.keys(OrderType) as OrderType[];

export type MaterialColor = string;

export interface Order {
  id: string;
  office: {
    id: string;
    name: string;
    email: string;
    phone: number;
    street: string;
    house_number: string;
    zipcode: string;
    city: string;
    bank_account?: string;
    chamber_of_commerce?: number;
    vat_number: string;
    type: "USER" | "OFFICE";
    isActive: boolean;
    created_at: number;
    updated_at: number;
  };
  user: {
    id: string;
    first_name: string;
    last_name: string;
    email: string;
    phone: number;
    street: string;
    house_number: string;
    zipcode: string;
    city: string;
    type: "USER" | "ADMIN";
    role: "USER" | "ADMIN" | "OWNER";
    isActive: boolean;
    created_at: number;
    updated_at: number;
  };
  stairMaterial: Material;
  stairColor: MaterialColor;
  stairAmount: number;
  stairPrice: number;
  risersMaterial: Material | null;
  risersColor: MaterialColor | null;
  risersAmount: number | null;
  risersPrice: number | null;
  specialRiserId?: string | null;
  specialRiserAmount?: number | null;
  specialRiserPrice?: number | null;
  specialRiser?: {
    id: string;
    name: string;
    description?: string | null;
    pricePerUnit: number;
    imageUrl?: string | null;
  } | null;
  topMaterial: Material;
  topColor: MaterialColor;
  topAmount: number;
  topPrice: number;
  first_name: string;
  last_name: string;
  email: string;
  phone: string;
  street: string;
  house_number: string;
  zipcode: string;
  city: string;
  assembly: boolean;
  finalPrice: number;
  extrasLed: boolean;
  extrasPlateau: boolean;
  plateauMaterial: Material;
  type: OrderType;
  profileColor: ProfileColor;
  assemblyPrice: number;
  ledPricing: number;
  // Snapshot LED-montagetoeslag; oude orders hebben deze kolom niet (null).
  ledAssemblyPrice?: number | null;
  ledMode?: string | null;
  ledCustomText?: string | null;
  letherPricing: number;
  plateauPrice: number;
  plateauSize?: string | null;
  extrasVolfineer?: boolean;
  volfineerPrice?: number;
  volfineerOpenPrice?: number;
  fixedCostsJson?: string | null;
  fixedCostsPrice?: number;
  // Sinds rekenversie 2; oude orders hebben null (= 140 cm, recht).
  breedte?: number | null;
  trapvorm?: string | null;
  // Snapshot van de calculatieregels (JSON) en de rekenversie.
  pricingLinesJson?: string | null;
  pricingVersion?: number | null;
  margin: number;
  // Marge en btw uit de ene functie in de backend (pricing/verkoop.ts), in
  // hele centen. De frontend rekent ze niet zelf uit.
  bedragen?: {
    inkoopCents: number;
    inkoopBtwCents: number;
    margeCents: number;
    verkoopExclBtwCents: number;
    verkoopBtwCents: number;
    verkoopInclBtwCents: number;
  };
  // Welke documenten deze gebruiker bij deze order kan downloaden (GET /order/:id).
  documenten?: {
    orderbevestiging: boolean;
    paklijst: boolean;
    melding: string | null;
  };
  input_type: "OFFERTE" | "ORDER";
  // Gevuld wanneer de order via de partner-API binnenkwam (GET /order/:id en
  // POST /order). `afwijking` betekent dat de partner een ander bedrag berekende
  // dan wij; het bedrag op de order is altijd het onze.
  partner?: {
    referentie: string;
    afwijking: boolean;
    partnerTotaalCents: number;
    serverTotaalCents: number;
    verschilCents: number;
  } | null;
  emailSent?: boolean;
  emailSentAt?: number | null;
  created_at: number;
  updated_at: number;
}
